import templateUtil from './templateUtil'
import validateConverterUtil from '../../components/dynamicFrom/libs/validateConverterUtil'
import objectUtil from './objectUtil'
/***
 * 转换formItems为按照标签和分组的结构,同时设置对应字段默认值
 */
export function transformFormItems(formItems, initForm, getFormData, compileData) {
  const formData = initForm || {}
  const resItems = []
  let tagItem = null
  let groupItem = null
  for (let i = 0; i < formItems.length; i++) {
    const item = formItems[i]
    if (item.component?.code === 'formTag') {
      groupItem = null
      tagItem = item
      tagItem.children = []
      resItems.push(tagItem)
    } else if (item.component?.code === 'formGroup' && !!tagItem) {
      groupItem = item
      groupItem.children = []
      groupItem.parent = tagItem.code
      tagItem.children.push(groupItem)
    } else if (groupItem) {
      if (objectUtil.getValueByPath(formData, item.property) === null) {
        const defaultValue = item.defaultValue
          ? templateUtil.compileData(item.defaultValue, compileData)
          : null
        objectUtil.setValueByPath(formData, item.property, defaultValue)
      }
      item.validate = validateConverterUtil.converterValidates(item.validators, item, getFormData)
      groupItem.children.push(item)
    } else if (!tagItem) {
      tagItem = {
        name: '自动生成标签',
        label: '自动生成标签',
        code: objectUtil.createID(),
        component: {
          code: 'formTag',
        },
        children: [],
        visible: true,
      }
      resItems.push(tagItem)
      i -= 1
    } else if (!groupItem) {
      groupItem = {
        name: '自动生成分组',
        label: null,
        code: objectUtil.createID(),
        component: {
          code: 'formGroup',
        },
        children: [],
        parent: tagItem.code,
        visible: true,
      }
      tagItem.children.push(groupItem)
      i -= 1
    } else {
      console.error('transformFormItems转换错误')
    }
  }
  return {
    formData,
    resItems,
  }
}
